/**
 * Upper bound on a single entity id in the assistant's entity context. DMS record ids are UUIDs
 * (36 characters); 64 leaves headroom for prefixed or composite ids without letting a manipulated
 * client inflate the request.
 */
export const ASSISTANT_ENTITY_CONTEXT_ID_MAX_CHARACTERS = 64;
